const getCountry = (addressComponents = []) => {
  var _a;
  return (_a = addressComponents.find(({ types }) => types.includes("country"))) == null ? void 0 : _a.long_name;
};
const getCity = (addressComponents = []) => {
  var _a;
  return (_a = addressComponents.find(({ types }) => types.includes("locality"))) == null ? void 0 : _a.long_name;
};
const getState = (addressComponents = []) => {
  var _a;
  return (_a = addressComponents.find(({ types }) => types.includes("administrative_area_level_1"))) == null ? void 0 : _a.long_name;
};
const getZipCode = (addressComponents = []) => {
  var _a;
  return (_a = addressComponents.find(({ types }) => types.includes("postal_code"))) == null ? void 0 : _a.long_name;
};
const getStreet = (addressComponents = []) => {
  var _a;
  return (_a = addressComponents.find(({ types }) => types.includes("route"))) == null ? void 0 : _a.long_name;
};
const getNumber = (addressComponents = []) => {
  var _a;
  return (_a = addressComponents.find(({ types }) => types.includes("street_number"))) == null ? void 0 : _a.long_name;
};
const parsePlaceDetails = ({
  address_components: addressComponents
}) => ({
  city: getCity(addressComponents),
  country: getCountry(addressComponents),
  state: getState(addressComponents),
  zipCode: getZipCode(addressComponents),
  street: getStreet(addressComponents),
  number: getNumber(addressComponents)
});
const googlePlacesHelpers = { parsePlaceDetails };
export {
  googlePlacesHelpers
};
